import { createPinia } from "pinia";
import { createPersistedState } from "pinia-plugin-persistedstate";

export const pinia = createPinia();

pinia.use(
  createPersistedState({
    storage: localStorage,
  }),
);

// Import all stores to initialize them
import "./account";
import "./announcements";
import "./announcementCategories";
import "./appLocal";
import "./catalog";
import "./categories";
import "./checklistRows";
import "./checklists";
import "./collections";
import "./images";
import "./admin/features";
import "./admin/organisations";
import "./admin/roles";
import "./admin/templateCollections";
import "./admin/templates";
import "./admin/users";
import "./admin/vesselCatalogItem";
import "./admin/vessels";
